<template>

  <div id="form-container" ref="formContainer" v-if="application != null">
    <h1>View Application</h1>

    <div class="card" v-if="isAdmin()">
      <div class="card-header">Reviewer</div>
      <div class="card-body">
        <b-row>
          <b-col cols="6">
            <BaseSelector v-model="reviewer"
                          :v="$v.reviewer"
                          label="Reviewer"
                          slug="reviewer"
                          :options=reviewerOptions
                          setId="reviewer"
                          textField="username"
                          valueField="iamId"
            />
          </b-col>
          <b-col cols="1" rowspan="2">
            <b-button type="button" variant="success" @click="assignReviewer" role="button" class="mr-1 mt-4">Assign</b-button>
          </b-col>
          <b-col cols="1" rowspan="2" v-if="application.reviewer != null">
            <b-button type="button" variant="danger" @click="removeReviewer" role="button" class="mr-1 mt-4">Remove</b-button>
          </b-col>
        </b-row>
      </div>
    </div>

    <div class="card">
      <div class="card-header">Application Info</div>
      <div class="card-body">
        <b-row>
          <b-col cols="12"><span class="font-weight-bold">Program:</span> {{ application.appName.programNm }}</b-col>
        </b-row>
        <b-row>
          <b-col cols="12"><span class="font-weight-bold">Application Type:</span> {{ application.appName.applicationTypeNm }}</b-col>
        </b-row>
        <b-row>
          <b-col cols="12"><span class="font-weight-bold">Application Sub Type:</span> {{ application.appName.applicationSubTypeNm }}</b-col>
        </b-row>
        <b-row>
          <b-col cols="12"><span class="font-weight-bold">Application Number:</span> {{ application.applicationNumber }}</b-col>
        </b-row>
        <b-row v-if="application.hfid">
          <b-col cols="12" ><span class="font-weight-bold">HFID:</span> {{ application.hfid }}</b-col>
          <!--<b-col cols="12" v-else><span class="font-weight-bold">License number:</span> {{ application.hfid }}</b-col>-->
        </b-row>
        <b-row v-if="displayRevenue()">
          <b-col cols="12"><span class="font-weight-bold">Revenue:</span> {{ formatCurrency(application.revenue) }}</b-col>
        </b-row>
        <b-row class="pt-4">
          <b-col v-if="!isAdmin()">
            <b-button v-if="displayHfid()" type="button" variant="secondary" :to="'/attachments/'+appId" role="button" class="mr-1">Edit HFID</b-button>
            <b-button v-if="displayRevenue()" type="button" variant="secondary" :to="'/attachments/'+appId" role="button" class="mr-1">Edit Revenue</b-button>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="card">
      <div class="card-header">Submitter Info</div>
      <div class="card-body">
        <b-row>
          <b-col cols="6"><span class="font-weight-bold">Last Name: </span>{{application.submitter.lastName}}</b-col>
          <b-col cols="4"><span class="font-weight-bold">First Name: </span>{{application.submitter.firstName}}</b-col>
          <b-col cols="2" rowspan="2" v-if="!isReadonly && !isAdmin()">
            <b-button type="button" variant="secondary" :to="'/submitter/'+appId" role="button" class="mr-1">Edit Submitter</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6"><span class="font-weight-bold">Phone: </span>{{application.submitter.phone}}</b-col>
          <b-col cols="4"><span class="font-weight-bold">Email: </span>{{application.submitter.email}}</b-col>
        </b-row>
      </div>
    </div>
    <div class="card">
      <div class="card-header">Follow Up Contact Information</div>
      <div class="card-body">
        <div v-for="contact in contacts" :key="contact.id">
          <b-row>
            <b-col cols="6"><span class="font-weight-bold">Last Name: </span>{{contact.lastName}}</b-col>
            <b-col cols="4"><span class="font-weight-bold">First Name: </span>{{contact.firstName}}</b-col>
            <b-col cols="2" rowspan="2" v-if="!isReadonly && !isAdmin()">
              <b-button type="button" variant="secondary" :to="'/contacts/'+appId" role="button" class="mr-1">Edit Contacts</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6"><span class="font-weight-bold">Phone: </span>{{contact.phone}}</b-col>
            <b-col cols="4"><span class="font-weight-bold">Email: </span>{{contact.email}}</b-col>
          </b-row>
        </div>
        <div v-if="contacts.length === 0">
          <b-row>
            <b-col cols="10">No follow up contacts found.</b-col>
            <b-col cols="2" rowspan="2" v-if="!isReadonly && !isAdmin()">
              <b-button type="button" variant="secondary" :to="'/contacts/'+appId" role="button" class="mr-1">Edit Contacts</b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <!--div class="card" v-if="!isAdmin() && displayHfid()">
      <div class="card-header">HFID</div>
      <div class="card-body">
        <b-form id="card-form-container">
          <b-row class="align-items-center" cols="12">
            <b-col cols="10">
              <BaseTextOutput :label="application.hfid"
                              slug="hfid"
                              setId="hfid"/>
            </b-col>
            <b-col cols="2" rowspan="2">
              <b-button type="button" variant="secondary" :to="'/attachments/'+appId" role="button" class="mr-1">Edit HFID</b-button>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div-->
    <div>
      <b-row>
        <b-col cols="10">
          <b-dropdown text="Download All Documents" variant="outline-primary" class="mb-2">
            <b-dropdown-item @click="downloadAll" :disabled="downloadDisabled">
              separately
            </b-dropdown-item>
            <b-dropdown-item @click="downloadAllAsZip" :disabled="downloadDisabled">
              as zip
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col cols="2" class="p-0 mb-2" v-if="!isReadonly && !isAdmin()">
          <b-button type="button" variant="secondary" :to="'/attachments/'+appId" role="button">Edit Documents</b-button>
        </b-col>
      </b-row>
      <div class="card">
        <div class="card-header">Documents</div>
        <div class="card-body" v-if="documentTypes && documentTypes.length > 0 ">
          <div v-for="(documentType, index) in documentTypes" :key="documentType.id">
            <b-row class="mb-1 mt-1">
              <b-col class="font-weight-bold">
                {{documentType.name}}
              </b-col>
            </b-row>
            <b-row v-bind:class="{'border-bottom':index !== documentTypes.length-1}" class="pb-2">
              <b-col>
                {{documentType.description}}
              </b-col>
            </b-row>
            <b-row class="border-bottom">
              <b-col cols="12">
                <DocumentTable :applicationId="application.id" :isView="true"
                               :documentTypeId="documentType.id" :documentTypeName="documentType.name"/>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <div class="card" v-if="!isStatus(['DRAFT'])">
        <div class="card-header">Notes</div>
        <div class="card-body">
          <b-row>
            <b-col cols="12">
              <p style="font-weight:750;" class="mb-1">Public Notes</p>
              <b-table hover small responsive show-empty
                       class="sr-caption"
                       id="notes"
                       :fields="noteFields"
                       :items="notes"
                       primary-key="id"
                       :busy="isNoteLoading"
                       label-sort-asc=""
                       label-sort-desc=""
                       caption="Public Notes table.  To sort the data in this table by a specific column, go to the appropriate column header
                   cell and use enter to sort the data ascending.  Use enter again to sort descending.">

                <template v-slot:no-data>
                  No Notes Found.
                </template>
                <template v-slot:empty="scope">
                  <p>No notes found.</p>
                </template>

                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle spinner-margin"></b-spinner>
                  <strong>Loading, Please Wait...</strong>
                </div>

                <template v-slot:cell(createdDate)="row">
                  {{momentFormat(row.item.createdDate)}}
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button v-if="isOwnedNote(row.item)"
                            @click="showExtNoteModal(row.item)"
                            variant="warning"
                            class="mr-1 mt-1"
                  >
                    Edit
                  </b-button>
                  <b-button v-if="isOwnedNote(row.item)"
                            @click="showDeleteNoteModal(row.item, false)"
                            variant="danger"
                            class="mr-1 mt-1"
                  >
                    Delete
                  </b-button>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <BaseParagraphInput v-model="extNote"
                                  :v="$v.extNote"
                                  label="Public Note:"
                                  setId="notes-textarea"
              />
            </b-col>
          </b-row>
          <b-row cols="12">
            <b-button @click="externalNote()" class="mr-2 btn btn-secondary">Create Public Note</b-button>
          </b-row>
          <div v-if="isAdmin()" class="mb-3">
            <b-row class="mt-2">
              <b-col cols="12">
                <p style="font-weight:750;" class="mb-1">Internal Notes</p>
                <b-table hover small show-empty class="sr-caption"
                         responsive="true"
                         :fields="noteFields"
                         :items="internalNotes"
                         :busy="isIntNoteLoading"
                         label-sort-asc=""
                         label-sort-desc=""
                         caption="Internal Notes table.  To sort the data in this table by a specific column,
                                  go to the appropriate column header cell and use enter to sort the data ascending.
                                  Use enter again to sort descending.">
                  <template v-slot:no-data>
                    No Notes Found.
                  </template>
                  <template slot="empty" slot-scope="scope">
                    No Notes Found.
                  </template>

                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>

                  <template v-slot:cell(createdDate)="row">
                    {{momentFormat(row.item.createdDate)}}
                  </template>
                  <template v-slot:cell(actions)="row">
                    <b-button v-if="isOwnedNote(row.item)"
                              @click="showIntNoteModal(row.item)"
                              variant="warning"
                              class="mr-1 mt-1"
                    >
                      Edit
                    </b-button>
                    <b-button v-if="isOwnedNote(row.item)"
                              @click="showDeleteNoteModal(row.item, true)"
                              variant="danger"
                              class="mr-1 mt-1"
                    >
                      Delete
                    </b-button>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <BaseParagraphInput v-model="intNote"
                                    :v="$v.intNote"
                                    label="Internal Note:"
                                    setId="notes-textarea"
                />
              </b-col>
            </b-row>
            <b-row cols="12">
              <b-button @click="internalNote()" class="mr-2 btn btn-secondary">Create Internal Note</b-button>
            </b-row>
          </div>
        </div>
      </div>
      <div class="card" v-if="isStatus(['WAITING_FOR_PAYMENT', 'PAID', 'SENT_TO_DEPOSIT_TEAM', 'SENT_TO_CREDENTIALER']) && invoice != null">
        <div class="card-header">Invoice</div>
        <div class="card-body">
          <b-row>
            <b-col><span class="font-weight-bold">Invoice Date: </span>{{momentFormat(invoice.date)}}</b-col>
          </b-row>
          <b-row class="align-items-center mb-2">
            <b-col cols="5"><span class="font-weight-bold">Total Invoiced Amount: </span>${{invoice.totalAmount}}</b-col>
            <b-col cols="5"><span class="font-weight-bold">Balance Due: </span>${{invoice.balanceDue}}</b-col>
            <b-col cols="2" v-if="!isAdmin() && invoice.balanceDue > 0">
              <b-button @click="pay"
                        variant="warning"
                        class="mr-1"
                        >
                Pay
              </b-button>
            </b-col>
            <b-col cols="2" v-if="isAdmin() && isStatus(['WAITING_FOR_PAYMENT']) && !isPayLoading && payments.length === 0">
              <b-button @click="showAllocationsModal"
                        variant="warning"
                        class="mr-1"
              >
                Update Fee
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-table hover small responsive show-empty
                     class="sr-caption"
                     id="allocations"
                     :fields="allocationsFields"
                     :items="decision.allocations"
                     primary-key="id"
                     :busy="isInvoiceLoading"
                     label-sort-asc=""
                     label-sort-desc=""
                     caption="Fees Invoice table.  To sort the data in this table by a specific column, go to the appropriate column header
                   cell and use enter to sort the data ascending.  Use enter again to sort descending.">

              <template v-slot:empty="scope">
                <p>No fees found for invoice.</p>
              </template>

              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle spinner-margin"></b-spinner>
                <strong>Loading, Please Wait...</strong>
              </div>

              <template v-slot:cell(amount)="row">
                ${{row.item.amount}}
              </template>
            </b-table>
          </b-row>
        </div>
      </div>
      <div class="card" v-if="isStatus(['WAITING_FOR_PAYMENT', 'PAID', 'SENT_TO_DEPOSIT_TEAM', 'SENT_TO_CREDENTIALER'])">
        <div class="card-header">Payments</div>
        <div class="card-body">
          <b-table hover small responsive show-empty
                   class="sr-caption"
                   id="payments"
                   :fields="payFields"
                   :items="payments"
                   primary-key="id"
                   :busy="isPayLoading"
                   label-sort-asc=""
                   label-sort-desc=""
                   caption="Payments table.  To sort the data in this table by a specific column, go to the appropriate column header
                   cell and use enter to sort the data ascending.  Use enter again to sort descending.">

            <template v-slot:empty="scope">
              <p>No payments found.</p>
            </template>

            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle spinner-margin"></b-spinner>
              <strong>Loading, Please Wait...</strong>
            </div>

            <template v-slot:cell(paymentDate)="row">
              {{momentFormat(row.item.paymentDate)}}
            </template>
          </b-table>
        </div>
      </div>
      <div class="card" v-if="isAdmin()">
        <div class="card-header">Status Events</div>
        <div class="card-body">
          <b-table hover small responsive show-empty
                   class="sr-caption"
                   id="statusEvents"
                   :fields="eventFields"
                   :items="statusEvents"
                   :busy="isEventsLoading"
                   primary-key="id"
                   label-sort-asc=""
                   label-sort-desc=""
                   caption="Application Status Event table.  To sort the data in this table by a specific column, go to the appropriate column
                     header cell and use enter to sort the data ascending.  Use enter again to sort descending.">

            <template v-slot:empty="scope">
              <p>No events found.</p>
            </template>

            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle spinner-margin"></b-spinner>
              <strong>Loading, Please Wait...</strong>
            </div>

            <template v-slot:cell(createdDate)="row">
              {{momentFormat(row.item.createdDate)}}
            </template>
          </b-table>
        </div>
      </div>
      <div class="card" v-if="isAdmin() && isStatus(['PAID'])">
        <div class="card-header">HFID</div>
        <div class="card-body">
          <b-form id="card-form-container">
            <b-row class="align-items-center" cols="12">
              <!--TODO: line up HFID and button-->
              <b-col cols="6">
                <BaseTextInput v-model="send.hfid"
                               :v="$v.send.hfid"
                               label="HFID"
                               slug="hfid"
                               setId="hfid"/>
              </b-col>
              <b-col cols="6">
                <b-button @click="sendToDepositTeam" class="mr-2 mt-3 btn btn-success">Send To Deposit Team</b-button>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </div>

      <div class="card" v-if="isAdmin() && isStatus(['SENT_TO_DEPOSIT_TEAM','SENT_TO_CREDENTIALER'])">
        <div class="card-header">HFID</div>
        <div class="card-body">
          <b-form id="card-form-container">
            <b-row class="align-items-center" cols="12">
              <b-col cols="2">
                <BaseTextOutput :label="send.hfid"
                                slug="hfid"
                                setId="hfid"/>
              </b-col>
              <b-col cols="6">
                <b-button @click="sendToCredentialer" class="mr-2 mt-3 btn btn-success">Send To Credentialer</b-button>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </div>

      <!--
      <div class="card" v-if="isAdmin() && isStatus(['SENT_TO_CREDENTIALER'])">
        <div class="card-header">HFID</div>
        <div class="card-body">
          <b-form id="card-form-container">
            <b-row class="align-items-center" cols="12">
              <b-col cols="6">
                <BaseTextInput v-model="send.hfid"
                                :v="$v.send.hfid"
                                label="HFID"
                                slug="hfid"
                                setId="hfid"/>
              </b-col>
              <b-col cols="6">
                <b-button @click="sendToCredentialer" class="mr-2 mt-3 btn btn-success">Send To Credentialer</b-button>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </div>
      -->

      <div class="card" v-if="isAdmin() && isStatus(['SUBMITTED', 'RE_SUBMITTED', 'IN_REVIEW'])">
        <div class="card-header">Review Application</div>
        <div class="card-body">
          <b-form id="card-form-container">
            <b-row>
              <b-col>
                <div class="text-danger" v-if="!this.validateTotal && this.$v.decision.$dirty">
                  Total amount minimum is $1.00
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <BaseParagraphInput v-model="decision.note"
                                    :v="$v.decision.note"
                                    label="Notes:"
                                    setId="notes-textarea"
                />
              </b-col>
            </b-row>
            <b-row>
              <h2>Payment Allocation (only if application is accepted)</h2>
            </b-row>
            <b-row v-for="(allocation, index) in decision.allocations" :key="index">
              <b-col cols="4" v-if="isAdmin()">
                <BaseTextOutput label="Speed Chart Code" :value="allocation.speedChart.code"/>
              </b-col>
              <b-col cols="4">
                <BaseTextOutput label="Fee Type" :value="allocation.speedChart.name"/>
              </b-col>
              <b-col cols="4">
                <BaseMoneyInput v-model="allocation.amount"
                                :v="$v.decision.allocations.$each[index].amount"
                                label="Amount"
                                slug="allocationsAmount"
                                :setId="'allocationsAmount'+index"/>
              </b-col>
            </b-row>
            <b-row v-if="this.application.appName.programNm.includes('Home') || this.application.appName.programNm.includes('Assisted Living')">
              <b-col cols="4" offset="8">
                <b-form-checkbox
                  v-model="hasFee"
                  @change="updateFee"
                >
                  Include NSF Fee
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="float-right" cols="12">
              <b-button @click="showAcceptModal" class="mr-2 btn btn-success">Accept Application</b-button>
              <b-button @click="showRejectModal" class="mr-2 btn btn-danger">Reject Application</b-button>
            </b-row>
          </b-form>
        </div>
      </div>
      <div class="card" v-if="isAdmin() && isStatus(['WAITING_FOR_PAYMENT']) && !isPayLoading && payments.length === 0">
        <div class="card-header">Review Application</div>
        <div class="card-body">
          <b-form id="card-form-container">
            <b-row>
              <b-col cols="12">
                <BaseParagraphInput v-model="decision.note"
                                    :v="$v.decision.note"
                                    label="Notes:"
                                    setId="notes-textarea"
                />
              </b-col>
            </b-row>
            <b-row cols="12">
              <b-button @click="showStatusChangeModal('SUBMITTED')" class="mr-2 btn btn-warning">Reset Status to SUBMITTED</b-button>
              <b-button @click="showStatusChangeModal('REOPEN')" class="mr-2 btn btn-warning">Reset Status to REOPEN</b-button>
            </b-row>
          </b-form>
        </div>
      </div>
    </div>

    <b-modal id="accept-modal" hide-header hide-footer>
      <h2>Accept Application</h2>
      <hr/>
      <form ref="form" @submit.prevent="accept">
        You are about to accept the application from user {{application.submitter.firstName}} {{application.submitter.lastName}}
        with the following fees:
        <div v-for="(allocation, index) of decision.allocations" :key="index" class="mt-1">
          <div>
            <span class="font-weight-bold">Payment Allocation: </span> {{allocation.speedChart.code}}: {{allocation.speedChart.name}}
          </div>
          <div>
            <span class="font-weight-bold">Amount: </span> ${{allocation.amount}}
          </div>
        </div>
        <p>Please check that the amount
        is correct, and be aware that any notes entered here will be visible to the applicant.</p>
        <p class="mt-2">Press Confirm to accept or Cancel to return to the application review.</p>
        <div>
          <b-button @click="closeAcceptModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
          <b-button type="submit" variant="primary">Confirm</b-button>
        </div>
      </form>
    </b-modal>
    <b-modal id="reject-modal" hide-header hide-footer>
      <h2>Reject Application</h2>
      <hr/>
      <form ref="form" @submit.prevent="reject">
        You are about to reject the application from user {{application.submitter.firstName}} {{application.submitter.lastName}}.
        Please be aware that any notes entered here will be visible to the applicant.
        <p class="mt-2">Press Confirm to reject or Cancel to return to the application review.</p>
        <div>
          <b-button @click="closeRejectModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
          <b-button type="submit" variant="primary">Confirm</b-button>
        </div>
      </form>
    </b-modal>
    <b-modal id="status-change-modal" hide-header hide-footer>
      <h2>Change Application Status</h2>
      <hr/>
      <form ref="form" @submit.prevent="changeStatus()">
        You are about to change the application status to {{status}}.
        Please be aware that any notes entered here will be visible to the applicant.
        <p class="mt-2">Press Confirm to change status or Cancel to return to the application review.</p>
        <div>
          <b-button @click="closeStatusChangeModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
          <b-button type="submit" variant="primary">Confirm</b-button>
        </div>
      </form>
    </b-modal>
    <b-modal id="allocations-modal" hide-header hide-footer>
      <h2>Update Application Fee</h2>
      <hr/>
      <form ref="form" @submit.prevent="updateAllocations()" v-if="invoice">
        Current application fee is ${{invoice.totalAmount}}.
        <b-row>
          <b-col>
            <div class="text-danger" v-if="!this.validateTotal">
              Total amount minimum is $1.00
            </div>
          </b-col>
        </b-row>
        <b-row v-for="(allocation, index) in decision.allocations" :key="index">
          <b-col cols="4">
            <BaseTextOutput label="Speed Chart Code" :value="allocation.speedChart.code"/>
          </b-col>
          <b-col cols="4">
            <BaseTextOutput label="Fee Type" :value="allocation.speedChart.name"/>
          </b-col>
          <b-col cols="4">
            <BaseMoneyInput v-model="allocation.amount"
                            :v="$v.decision.allocations.$each[index].amount"
                            label="Amount"
                            slug="allocationsAmount"
                            :setId="'allocationsAmount'+index"/>
          </b-col>
        </b-row>
        <p class="mt-2">Press Confirm to update amount or Cancel to return to the application review.</p>
        <div>
          <b-button @click="closeAllocationsModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
          <b-button type="submit" variant="primary">Confirm</b-button>
        </div>
      </form>
    </b-modal>
    <b-modal id="int-note-modal" hide-header hide-footer>
      <h2>Edit Internal Note</h2>
      <hr/>
      <form ref="form" @submit.prevent="editIntNote()">
          <BaseParagraphInput v-model="intNote"
                              :v="$v.intNote"
                              label="Internal Note:"
                              setId="notes-textarea"
          />
        <p class="mt-2">Press Confirm to update the note or Cancel to return to the application review.</p>
        <div>
          <b-button @click="closeIntNoteModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
          <b-button type="submit" variant="primary">Confirm</b-button>
        </div>
      </form>
    </b-modal>
    <b-modal id="ext-note-modal" hide-header hide-footer>
      <h2>Edit Note</h2>
      <hr/>
      <form ref="form" @submit.prevent="editExtNote()">
        <BaseParagraphInput v-model="extNote"
                            :v="$v.extNote"
                            label="Note:"
                            setId="notes-textarea"
        />
        <p class="mt-2">Press Confirm to update the note or Cancel to return to the application review.</p>
        <div>
          <b-button @click="closeExtNoteModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
          <b-button type="submit" variant="primary">Confirm</b-button>
        </div>
      </form>
    </b-modal>
    <b-modal id="delete-note-modal" hide-header hide-footer>
      <h2>Delete Note</h2>
      <hr/>
      <form ref="form" @submit.prevent="deleteNote(selected, isInt)">
        You are about to delete this note: {{selected.text}}
        <p class="mt-2">Press Confirm to delete the note or Cancel to return to the application review.</p>
        <div>
          <b-button @click="closeDeleteNoteModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
          <b-button type="submit" variant="primary">Confirm</b-button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
  import DocumentTable from '@/components/templates/DocumentTable'
  import axios from 'axios'
  import axiosRetry from 'axios-retry'
  import { required, requiredIf, decimal, minValue } from 'vuelidate/lib/validators'
  import router from "@/router";
  import JSZip from "jszip";
  import * as FileSaver from 'file-saver';
  import DocumentService from "../services/DocumentService";
  import ConfigService from "@/services/ConfigService";
  import moment from 'moment';

  axiosRetry(axios, { retries: 3,
    retryDelay: axiosRetry.exponentialDelay  })

  export default {
    data: () => ({
      application: null,
      appId: null,
      documentTypes: [],
      documents: [],
      contacts: [],
      notes: [],
      payments: [],
      statusEvents: [],
      reviewerOptions: [],
      reviewer: null,
      invoice: null,
      decision: {
        note: null,
        allocations: [],
      },
      send: {
        hfid: null
      },
      feeAllocation: {
        amount: null,
        speedChart: {}
      },
      hasFee: false,
      isReadonly: true,
      isAccepted: false,
      isNoteLoading: true,
      isIntNoteLoading: true,
      isPayLoading: true,
      isInvoiceLoading: true,
      isEventsLoading: true,
      downloadDisabled: false,
      selected: {},
      isInt: false,
      intNote: "",
      extNote:"",
      internalNotes: [],
      inoteId: null,
      enoteId: null,
      noteFields: [
        {key: 'text', sortable: true, label: 'Note', tdClass: 'col-8'},
        {key: 'createdDate', sortable: true, label: 'Date', tdClass: 'col-1'},
        {key: 'createdByName', sortable: true, label: 'Note By', tdClass: 'col-1'},
        {key: 'actions', sortable: true, label: 'Actions', tdClass: 'col-2'}
      ],
      allocationsFields: [
        {key: 'speedChart.name', sortable: true, label: 'Fee Type'},
        {key: 'amount', sortable: true, label: 'Amount'},
      ],
      payFields: [
        {key: 'paymentDate', sortable: true, label: 'Date'},
        {key: 'amount', sortable: true, label: 'Amount Paid'},
        {key: 'status', sortable: true, label: 'Status'},
        {key: 'paymentMethod', sortable: true, label: 'Payment Method'},
        {key: 'confirmationId', sortable: true, label: 'Confirmation #'},
      ],
      eventFields: [
        {key: 'operationType', sortable: true, label: 'Event Type'},
        {key: 'action', sortable: true, label: 'Event'},
        {key: 'createdDate', sortable: true, label: 'Event Date'},
        {key: 'createdByName', sortable: true, label: 'Event By'},
      ],
      status: null,
    }),
    components: {
      DocumentTable,
    },
    created() {
      document.title = "View Application - Facility and Provider Licensing System"
      this.appId = this.$route.params.id
      this.loadApplication()
      this.loadDocumentTypes()
      this.loadContacts()
      if (this.isAdmin()) {
        this.allocationsFields.splice(this.allocationsFields.length - 2, 0,
                {key: 'speedChart.code', sortable: true, label: 'Speed Chart Code'})
        this.loadReviewers()
        this.loadEvents()
      }
    },
    methods: {
      loadApplication() {
        axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId)
          .then(response => {
            this.application = response.data
            if (this.application.hfid != null) {
              this.send.hfid = this.application.hfid
            }
            if (this.application.reviewer != null) {
              this.reviewer = this.application.reviewer.iamId
            }
            this.isReadonly = !this.isStatus(["DRAFT","REOPEN"])
            if (!this.isStatus(['DRAFT'])) {
              this.loadNotes()
              if (this.isAdmin()) {
                this.loadInternalNotes()
              }
            }
            if (this.isStatus(['WAITING_FOR_PAYMENT', 'PAID', 'SENT_TO_DEPOSIT_TEAM', 'SENT_TO_CREDENTIALER'])) {
              this.loadInvoice()
              this.loadPayments()
            }
            if (this.isStatus(['SUBMITTED','RE_SUBMITTED','IN_REVIEW']) && this.isAdmin()) {
              this.loadSpeedCharts()
            }
          })
      },
      loadNotes() {
        axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + "/notes-external")
                .then(response => {
                  this.notes = response.data
                  this.isNoteLoading = false
                })
      },
      loadInternalNotes() {
        axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + "/notes-internal")
                .then(response => {
                  this.internalNotes = response.data
                  this.isIntNoteLoading = false
                })
      },
      loadDocumentTypes() {
        axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + '/document-types/')
          .then(response => {
            this.documentTypes = response.data
          })
      },
      loadContacts() {
        axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + '/contacts')
                .then(response => {
                  if(response.data.length > 0) {
                    this.contacts = response.data
                    this.application.contacts = response.data
                  }
                })
      },
      loadInvoice() {
        axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + "/invoice")
                .then(response => {
                  this.invoice = response.data
                  this.decision.allocations = response.data.allocations
                  this.isInvoiceLoading = false
                })
      },
      loadPayments() {
        axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + "/payments")
                .then(response => {
                  this.payments = response.data
                  this.isPayLoading = false
                })
      },
      loadReviewers() {
        axios.get(ConfigService.getApiUrl() + `/api/users/reviewers`)
                .then(response => {
                  this.reviewerOptions = response.data
                })
      },
      loadEvents() {
        axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + "/events")
                .then(response => {
                  this.statusEvents = response.data
                  this.isEventsLoading = false;
                })
      },
      loadSpeedCharts() {
        axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + "/speed-charts/available")
                .then(response => {
                  response.data.forEach(chart => {
                    let totalAmount = 0;

                    //ALF Relocation fee
                    if (this.application.appName.programNm === 'Assisted Living Facilities Relocation') {
                      totalAmount += 3905;
                    }

                    //COMP and BASIC fee
                    if (chart.code === 'H12HCPLIC') {
                      if (this.application.appName.programNm.includes('Comprehensive')) {
                        totalAmount += 4200;
                      } else if (this.application.appName.programNm.includes('Basic')) {
                        totalAmount += 2100;
                      }
                    }

                    //HCBS fee
                    if (chart.code === 'H12HCBS1') {
                      totalAmount += 155;
                    } else if (chart.code === 'H12HCBS2') {
                      if (this.application.revenue > 1500000) {
                        totalAmount += 320
                      } else if (this.application.revenue > 1275000) {
                        totalAmount += 300
                      } else if (this.application.revenue > 1100000) {
                        totalAmount += 280
                      } else if (this.application.revenue > 950000) {
                        totalAmount += 260
                      } else if (this.application.revenue > 850000) {
                        totalAmount += 240
                      } else if (this.application.revenue > 750000) {
                        totalAmount += 220
                      } else if (this.application.revenue > 650000) {
                        totalAmount += 200
                      } else if (this.application.revenue > 550000) {
                        totalAmount += 180
                      } else if (this.application.revenue > 450000) {
                        totalAmount += 160
                      } else if (this.application.revenue > 350000) {
                        totalAmount += 140
                      } else if (this.application.revenue > 250000) {
                        totalAmount += 120
                      } else if (this.application.revenue > 100000) {
                        totalAmount += 100
                      } else if (this.application.revenue > 50000) {
                        totalAmount += 80
                      } else if (this.application.revenue > 25000) {
                        totalAmount += 60
                      } else {
                        totalAmount += 40
                      }
                    }

                    if (!chart.name.includes("NSF")) {
                      this.decision.allocations.push({speedChart: chart, amount: totalAmount})
                    } else {
                      this.feeAllocation.speedChart = chart
                      this.feeAllocation.amount = 30
                    }
                  })
                })
      },
      isStatus(status) {
        return status.some(s => s === this.application.status)
      },
      pay() {
        const payload = {
          returnUrl: location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: '') + '/#/dashboard'
        }
        axios.post(ConfigService.getApiUrl() +`/api/applications/` + this.appId + "/make-payment", payload)
          .then(response => {
            this.sendToUSBank(response.data)
          }).catch(err => {
            if (err.response) {
              let errorList = Object.values(err.response.data)
              this.showRootToast("Error", this.createErrorToast(errorList),
                      "danger")
            } else {
              this.showRootToast("Error", "Application was unable to connect.  Please try again later.",
                      "danger")
            }
        })
      },

      sendToUSBank(formData) {
        var usbForm = document.createElement('form')
        usbForm.method = 'post'
        usbForm.action = formData['url']
        delete formData['url']
        for (var k in formData) {
          var input = document.createElement('input')
          input.setAttribute('name', k)
          input.setAttribute('value', formData[k])
          usbForm.appendChild(input) ;
        }
        document.body.appendChild(usbForm)
        usbForm.submit()
        document.body.removeChild(usbForm) ;
      },

      downloadAll(){
        this.downloadDisabled = true
        this.getAllDocuments().then(response => {
          this.documents.forEach(dl => {
            const docTypeName = this.getDocTypeName(dl.documentTypeId)
            axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + '/documents/' + dl.id, {
              responseType: 'arraybuffer'
            }).then(response => {
              const blob = DocumentService.convertToBlob(response.data, response.headers["content-type"])
              FileSaver.saveAs(blob, docTypeName+" - "+dl.name);
              this.downloadDisabled = false
            })
          })
        })
      },
      downloadAllAsZip() {
        this.downloadDisabled = true
        this.getAllDocuments().then(response => {
          const zip = new JSZip();
          const cache = {};
          const promises = [];
          this.documents.forEach(dl => {
            const docTypeName = this.getDocTypeName(dl.documentTypeId)
            const promise = axios.get(ConfigService.getApiUrl() + `/api/applications/` + this.appId + '/documents/' + dl.id, {
              responseType: 'arraybuffer'
            }).then(response => {
              zip.file(docTypeName+" - "+dl.name, response.data, {binary: true})
              cache[docTypeName+" - "+dl.name] = response.data
            }).catch((err) => {
              console.log(err)
              this.downloadDisabled = false
            })
            promises.push(promise);
          })
          Promise.all(promises).then(() => {
            zip.generateAsync({type: "blob"}).then(content => {
              FileSaver.saveAs(content, "_documents.zip");
              this.downloadDisabled = false
            })
          })
        })
      },
      async getAllDocuments() {
        const payload = {
          documentTypeId: ''
        }
        return axios.get(ConfigService.getApiUrl() + `/api/applications/` + this.appId + "/documents", {params: payload})
          .then(response => {
            this.documents = response.data
          })
      },
      getDocTypeName(id) {
        return this.documentTypes.filter(dt => dt.id === id).map(dt => dt.name)[0]
      },
      assignReviewer() {
        this.$v.reviewer.$touch();
        if (this.$v.reviewer.$invalid) {
          return
        }
        axios.put(ConfigService.getApiUrl() + `/api/applications/` + this.appId + '/reviewer', this.reviewer)
          .then(response => {
            this.showRootToast("Application Updated", "Reviewer Updated", "success")
            this.application.reviewer = this.reviewer
          }).catch(err => {
            if (err.response) {
              let errorList = Object.values(err.response.data)
              this.showRootToast("Error", this.createErrorToast(errorList),
                      "danger")
            } else {
              this.showRootToast("Error", "Application was unable to connect.  Please try again later.",
                      "danger")
            }
        })
      },
      removeReviewer() {
        axios.put(ConfigService.getApiUrl() + `/api/applications/` + this.appId + '/reviewer', null)
          .then(response => {
            this.showRootToast("Application Updated", "Reviewer Updated", "success")
            this.application.reviewer = null
            this.reviewer = null
          }).catch(err => {
            if (err.response) {
              let errorList = Object.values(err.response.data)
              this.showRootToast("Error", this.createErrorToast(errorList),
                      "danger")
            } else {
              this.showRootToast("Error", "Application was unable to connect.  Please try again later.",
                      "danger")
            }
        })
      },
      accept() {
        this.isAccepted = true;
        this.$v.decision.$touch();
        if (this.$v.decision.$invalid || !this.validateTotal) {
          this.closeAcceptModal()
          return
        }
        const payload = {
          applicationId: this.appId,
          notes: this.decision.note,
          allocations: this.decision.allocations
        }
        axios.post(ConfigService.getApiUrl() + `/api/applications/` + this.appId + '/accept', payload)
          .then(response => {
            this.showRootToast("Accepted", "Application status updated: Accepted", "success")
            this.closeAcceptModal()
            setTimeout(() => {
              router.push("/dashboard")
            }, 200)
          }).catch(err => {
            let errorList = Object.values(err.response.data)
            this.showRootToast("Error", this.createErrorToast(errorList),
                  "danger")
            this.closeAcceptModal()
        })
      },
      reject() {
        const payload = {
          applicationId: this.appId,
          notes: this.decision.note
        }
        this.decision.note = null;
        axios.post(ConfigService.getApiUrl() + `/api/applications/` + this.appId + '/reject', payload)
          .then(response => {
            this.showRootToast("Rejected", "Application status updated: Rejected", "success")
            this.closeRejectModal()
            setTimeout(() => {
              router.push("/dashboard")
            }, 200)
          }).catch(err => {
            this.showRootToast("Error", "An error occurred while processing the decision: " + err.response.data,
                  "danger")
            this.closeRejectModal()
        })
      },
      sendToDepositTeam() {
        this.$v.send.$touch();
        if (this.$v.send.$invalid) {
          return
        }
        const payload = {
          hfid: this.send.hfid
        }
        axios.post(ConfigService.getApiUrl() + `/api/applications/` + this.appId + '/sent-to-deposit-team', payload)
            .then(response => {
              this.showRootToast("Sent to Deposit Team", "Application status updated: Sent to Deposit Team", "success")
              this.closeRejectModal()
              setTimeout(() => {
                router.push("/dashboard")
              }, 200)
            }).catch(err => {
          let errorList = Object.values(err.response.data)
          this.showRootToast("Error", this.createErrorToast(errorList),
              "danger")
          this.closeRejectModal()
        })
      },
      sendToCredentialer() {
        this.$v.send.$touch();
        if (this.$v.send.$invalid) {
          return
        }
        const payload = {
          hfid: this.send.hfid
        }
        axios.post(ConfigService.getApiUrl() + `/api/applications/` + this.appId + '/sent-to-credentialer', payload)
          .then(response => {
            this.showRootToast("Sent to Credentialer", "Application status updated: Sent to Credentialer", "success")
            this.closeRejectModal()
            setTimeout(() => {
              router.push("/dashboard")
            }, 200)
          }).catch(err => {
            let errorList = Object.values(err.response.data)
            this.showRootToast("Error", this.createErrorToast(errorList),
                "danger")
            this.closeRejectModal()
        })
      },
      changeStatus() {
        const payload = {
          applicationId: this.appId,
          notes: this.decision.note,
          status: this.status,
        }
        this.decision.note = null;
        axios.post(ConfigService.getApiUrl() + `/api/applications/` + this.appId + '/change-status', payload)
                .then(response => {
                  this.showRootToast("Status Changed", "Application status updated: "+this.status, "success")
                  this.closeStatusChangeModal()
                  setTimeout(() => {
                    router.push("/dashboard")
                  }, 200)
                }).catch(err => {
          this.showRootToast("Error", "An error occurred while processing the decision: " + err.response.data,
                  "danger")
          this.closeStatusChangeModal()
        })
      },
      updateAllocations() {
        this.$v.decision.$touch();
        if (this.$v.decision.allocations.$invalid || !this.invoice || !this.validateTotal) {
          return
        }
        const payload = {
          applicationId: this.appId,
          allocations: this.decision.allocations,
          invoiceId: this.invoice.id
        }
        axios.put(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + '/invoice', payload)
                .then(response => {
                  this.loadInvoice()
                  this.showRootToast("Updated", "Application fee updated", "success")
                  this.closeAllocationsModal()
                }).catch(err => {
          let errorList = Object.values(err.response.data)
          this.showRootToast("Error", this.createErrorToast(errorList),
                  "danger")
          this.closeAllocationsModal()
        })
      },
      isAdmin(){
        if (this.$keycloak) {
          return this.$keycloak.hasResourceRole("ADMIN", ConfigService.getBackendClientName())
        } else {
          return false;
        }
      },
      displayHfid(){
        //applicants for these programs should NOT be able to enter a hfid, that will be done by admin role
        return !(this.application.appName.programNm.includes('Provisional') || this.application.appName.programNm.includes('Temporary'))
      },
      displayRevenue(){
        return (this.application.appName.programNm.includes('Home and Community-Based Services') && this.application.appName.applicationTypeNm.includes('Renewal'))
      },
      formatCurrency(value) {
        if (typeof value !== "number") return "";
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD"
        }).format(value);
      },
      showRejectModal() {
        this.$bvModal.show('reject-modal')
      },
      closeRejectModal() {
        this.$bvModal.hide('reject-modal')
      },
      showAcceptModal() {
        this.$bvModal.show('accept-modal')
      },
      closeAcceptModal() {
        this.$bvModal.hide('accept-modal')
      },
      showStatusChangeModal(status) {
        this.status = status
        this.$bvModal.show('status-change-modal')
      },
      closeStatusChangeModal() {
        this.status = null
        this.$bvModal.hide('status-change-modal')
      },
      showAllocationsModal() {
        this.$bvModal.show('allocations-modal')
      },
      closeAllocationsModal() {
        this.$bvModal.hide('allocations-modal')
      },
      showIntNoteModal(row) {
        this.intNote = row.text
        this.inoteId = row.id
        this.$bvModal.show('int-note-modal')
      },
      closeIntNoteModal() {
        this.inoteId = null
        this.intNote = null
        this.$bvModal.hide('int-note-modal')
      },
      showExtNoteModal(row) {
        this.extNote = row.text
        this.enoteId = row.id
        this.$bvModal.show('ext-note-modal')
      },
      closeExtNoteModal() {
        this.enoteId = null
        this.extNote = null
        this.$bvModal.hide('ext-note-modal')
      },
      showDeleteNoteModal(row, isInt) {
        this.selected = row
        this.isInt = isInt
        this.$bvModal.show('delete-note-modal')
      },
      closeDeleteNoteModal() {
        this.$bvModal.hide('delete-note-modal')
      },
      showRootToast(title, message, type) {
        this.$root.$bvToast.toast(message, {
          title: title,
          toaster: 'b-toaster-top-center',
          solid: true,
          variant: type,
          appendToast: true,
          noAutoHide:true
        })
        this.toastFocus()
      },
      toastFocus() {
        setTimeout(() => {
          let elem = document.getElementsByClassName("toast")
          elem = elem[elem.length-1]
          elem.focus()
        }, 100)
      },
      createErrorToast(errors) {
        const h = this.$createElement
        const errNodes = h(
                'div',
                [
                  h('p','An error has occurred'),
                  h('ul', [
                    errors.map(e => {
                      return h('li', {attrs:{class: 'circle-list ml-4'}}, e)
                    })
                  ])
                ]
        )
        return errNodes
      },
      momentFormat(date) {
        return moment(date).format("MM/DD/YYYY hh:mm A")
      },
      internalNote() {
        this.$v.intNote.$touch();
        if (this.$v.intNote.$invalid) {
          return
        }
        const payload = {
          text: this.intNote
        }

        axios.post(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + "/notes-internal", payload)
          .then(response => {
            this.showRootToast("Success", "The note has been created.", "success")
            this.intNote = null
            this.loadInternalNotes()
            this.$v.intNote.$reset()
          }).catch(err => {
            if (err.response) {
              let errorList = Object.values(err.response.data)
              this.showRootToast("Error", this.createErrorToast(errorList),
                      "danger")
            } else {
              this.showRootToast("Error", "Application was unable to connect.  Please try again later.",
                      "danger")
            }
        })
      },
      editIntNote() {
        this.$v.intNote.$touch();
        if (this.$v.intNote.$invalid) {
          return
        }
        const payload = {
          text: this.intNote,
        }

        axios.put(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + "/notes-internal/"+ this.inoteId, payload)
          .then(response => {
            this.showRootToast("Success", "The note has been updated.",
                    "success")
            this.loadInternalNotes()
            this.closeIntNoteModal()
            this.$v.intNote.$reset()
          }).catch(err => {
            if (err.response) {
              let errorList = Object.values(err.response.data)
              this.showRootToast("Error", this.createErrorToast(errorList),
                      "danger")
            } else {
              this.showRootToast("Error", "Application was unable to connect.  Please try again later.",
                      "danger")
            }
        })
      },
      deleteIntNote(row) {
        axios.delete(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + "/notes-internal/"+ row.id)
          .then(response => {
            this.showRootToast("Success", "The note has been deleted.",
                    "success")
            this.loadInternalNotes()
            this.closeDeleteNoteModal()
          }).catch(err => {
            if (err.response) {
              let errorList = Object.values(err.response.data)
              this.showRootToast("Error", this.createErrorToast(errorList),
                      "danger")
            } else {
              this.showRootToast("Error", "Application was unable to connect.  Please try again later.",
                      "danger")
            }
        })
      },
      externalNote() {
        this.$v.extNote.$touch();
        if (this.$v.extNote.$invalid) {
          return
        }
        const payload = {
          text: this.extNote
        }

        axios.post(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + "/notes-external", payload)
          .then(response => {
            this.showRootToast("Success", "The note has been created.", "success")
            this.extNote = null
            this.loadNotes()
            this.$v.extNote.$reset()
          }).catch(err => {
            if (err.response) {
              let errorList = Object.values(err.response.data)
              this.showRootToast("Error", this.createErrorToast(errorList),
                      "danger")
            } else {
              this.showRootToast("Error", "Application was unable to connect.  Please try again later.",
                      "danger")
            }
        })
      },
      editExtNote() {
        this.$v.extNote.$touch();
        if (this.$v.extNote.$invalid) {
          return
        }
        const payload = {
          text: this.extNote,
        }

        axios.put(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + "/notes-external/"+ this.enoteId, payload)
          .then(response => {
            this.showRootToast("Success", "The note has been updated.",
                    "success")
            this.loadNotes()
            this.closeExtNoteModal()
            this.$v.extNote.$reset()
          }).catch(err => {
            if (err.response) {
              let errorList = Object.values(err.response.data)
              this.showRootToast("Error", this.createErrorToast(errorList),
                      "danger")
            } else {
              this.showRootToast("Error", "Application was unable to connect.  Please try again later.",
                      "danger")
            }
        })
      },
      deleteExtNote(row) {
        axios.delete(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + "/notes-external/"+ row.id)
          .then(response => {
            this.showRootToast("Success", "The note has been deleted.",
                    "success")
            this.loadNotes()
            this.closeDeleteNoteModal()
          }).catch(err => {
            if (err.response) {
              let errorList = Object.values(err.response.data)
              this.showRootToast("Error", this.createErrorToast(errorList),
                      "danger")
            } else {
              this.showRootToast("Error", "Application was unable to connect.  Please try again later.",
                      "danger")
            }
        })
      },
      deleteNote(row, isInt) {
        if (isInt) {
          this.deleteIntNote(row)
        } else {
          this.deleteExtNote(row)
        }
      },
      isOwnedNote(row) {
        return row.createdById === this.$keycloak.subject
      },
      updateFee() {
        if (!this.hasFee) {
          this.decision.allocations = this.decision.allocations.filter(obj => !obj.speedChart.name.includes("NSF"));
          return
        }
        this.decision.allocations.push(this.feeAllocation)
      }
    },

    computed: {
      validateTotal() {
        return this.decision.allocations.reduce((acc, a) => acc + parseFloat(a.amount), 0) >= 1.00
      },
    },

    validations() {
      return {
        decision: {
          note: { required:false },
          allocations: {
            required: requiredIf(function() { return this.isAccepted }),
            $each: {
              amount: {
                required: requiredIf(function() { return this.isAccepted }),
                decimal,
                isMoneyDecimal(dec) {
                  var moneyRegex = /^\d+(\.\d{1,2})?$|^(d+)?\.\d{1,2}$/
                  return moneyRegex.test(dec)
                },
                minValue: minValue(0),
              },
            }
          }
        },
        send: {
          hfid: { required }
        },
        reviewer: { required },
        intNote: { required },
        extNote: { required },
      }
    },
  }
</script>
